import { render, staticRenderFns } from "./DerbyPlayerInfo.vue?vue&type=template&id=0f21363c&"
import script from "./DerbyPlayerInfo.vue?vue&type=script&lang=js&"
export * from "./DerbyPlayerInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports